@if (showTable) {

  @if (profielNietIngevuld) {
    <snelstart-ui-alert type="danger" [showIcon]="true" [showCloseButton]="false">
      <strong>Profiel ontbreekt bij werknemer(s)</strong>
      <br>
      Om correct te kunnen verlonen moet elke werknemer een geldig profiel hebben.
      <br>
      Verwijder deze werknemer(s) en voeg ze opnieuw toe met het juiste profiel. Meer informatie over werknemer verwijderen en toepassen profiel vind je op Kennisplein.
    </snelstart-ui-alert>
  }

  <snelstart-ui-table [config]="tableConfig">

    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="string" name="nummer" width="100px">
      <snelstart-ui-table-col-header>
        Nr
      </snelstart-ui-table-col-header>
      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          @let persoon = record.werknemerGegevens?.persoon;
          {{ persoon?.personeelsnummer || '-' }}
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="string" name="naam" width="300px">
      <snelstart-ui-table-col-header>
        Naam
      </snelstart-ui-table-col-header>
      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          @let persoon = record.werknemerGegevens?.persoon;
          <div>
            {{ persoon?.voorletters }}
            {{ persoon?.tussenvoegsel || '' }}
            {{ persoon?.achternaam }}
          </div>
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="string" name="profile" width="200px">
      <snelstart-ui-table-col-header>
        profiel
      </snelstart-ui-table-col-header>
      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          @let dienstverband = record.werknemerGegevens?.dienstverbanden?.at(0);
          {{ dienstverband?.profielId || 'Niet ingevuld' }}
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="date" name="datumindienst" width="200px">
      <snelstart-ui-table-col-header>
        Datum in dienst
      </snelstart-ui-table-col-header>
      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          @let dienstverband = record.werknemerGegevens?.dienstverbanden?.at(0);
          @if(dienstverband?.datumInDienst) {
            {{ dienstverband?.datumInDienst | date: 'dd-MM-yyyy' }}
          } @else {
            -
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="date" name="contractduur" width="200px">
      <snelstart-ui-table-col-header>
        Contract
      </snelstart-ui-table-col-header>
      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          @let dienstverband = record.werknemerGegevens?.dienstverbanden?.at(0);
          @let contract = dienstverband?.contractGegevensList?.at(0);
          @if(contract) {
            @if(contract?.bepaaldeTijd) {
              Bepaalde tijd
            }
            @else {
              Onbepaalde tijd
            }
          } @else {
            -
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" columnType="date" name="datumuitdienst" width="200px">
      <snelstart-ui-table-col-header>
        Datum uit dienst
      </snelstart-ui-table-col-header>
      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          @let dienstverband = record.werknemerGegevens?.dienstverbanden?.at(0);
          @if(dienstverband?.datumUitDienst) {
            {{ dienstverband?.datumUitDienst | date: 'dd-MM-yyyy'}}
          } @else {
            -
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
  </snelstart-ui-table>
}

